/**
 * Utils : Encoding
 * ---
 * Unicode-safe base64 encoding/decoding.
 * window.btoa/atob only handle Latin-1; these helpers go through UTF-8
 * so characters like ’ or œ don't throw.
 */

export function encodeUnicodeBase64(str = "") {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
  return window.btoa(binary);
}

export function decodeUnicodeBase64(enc = "") {
  const binary = window.atob(enc);
  try {
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    // Links sent before the UTF-8 encoding were plain Latin-1 btoa output
    return binary;
  }
}
